import enhanceStudentsPage from "../../../hocs/enhanceStudentsPage";
import { StudentCourseResult } from "./StudentCourseResult";

const pageInfo = {
  title: "学習結果",
};

export default enhanceStudentsPage(StudentCourseResult, pageInfo);
